/*
Sohel 01/31/2023 2701334326 added request Letter Functionality
Akhila 04/06/2023 2701334326 Added date field in letter request and validation
Prakash 10-05-23 2701334326 add theme class name.
*/
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import React, {useEffect, useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {fetchAllLetterCode} from '../../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const RequestALetter = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {values, handleChange, errors, handleBlur, touched, setFieldValue} = props;
  const {allLetterCode} = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const dispatch = useDispatch();
  const overRideOption = [
    {key: 'A', value: 'A - Account'},
    {key: 'S', value: 'S - Seed'},
    {key: 'R', value: 'R - Route'},
  ];

  useEffect(() => {
    dispatch(fetchAllLetterCode());
  }, []);
  return (
    <Grid container spacing={4} className="new-standard-textfields m-0">
      <Grid item xs={4} className={`form-group ${classes.selectField}`}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            fullWidth
            name="applyTo"
            className={` select-gender ${classes.labelName}`}
            required
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched?.applyTo}
            error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {overRideOption.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors && errors.applyTo}</FormHelperText>
      </Grid>
      <Grid item xs={4} className={`form-group`}>
        <GuiAutoComplete
          classes={{
            option: classes.option,
          }}
          name="letterCode"
          id="letterCode"
          size="small"
          options={allLetterCode}
          onBlur={handleBlur}
          required
          value={values?.letterCode || 'none'}
          getOptionDisabled={(option) => option.letterCode === 'none'}
          getOptionLabel={(option) => {
            return option && option?.letterDescription ?
              option?.letterCode === null ?
                option?.letterDescription :
                option?.letterCode + ' - ' + option?.letterDescription :
              '';
          }}
          onChange={(e, value) => {
            setFieldValue('letterCode', value);
          }}
          renderInput={(params) => (
            <div className="select-field">
              <GuiTextField
                {...params}
                className={` ${classes.labelName}`}
                variant="outlined"
                margin="dense"
                required
                InputLabelProps={{shrink: true}}
                label="Letter Code"
                placeholder="Select Letter Code"
                touched={touched?.letterCode}
                error={Boolean(touched?.letterCode && errors?.letterCode)}
              />
            </div>
          )}
        />
        <FormHelperText>{touched?.letterCode && errors && errors.letterCode}</FormHelperText>
      </Grid>
      <Grid item xs={4} className={`form-group`}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container>
            {/* <label>Date:</label> */}
            <KeyboardDatePicker
              format="MM/dd/yyyy"
              placeholder="MM/DD/YYYY"
              fullWidth
              className={` ${classes.labelName}`}
              // disabled={disabledAllFields}
              value={values.date}
              name="date"
              label="Date"
              minDate={new Date()}
              // InputLabelProps={{
              //   shrink: true,
              // }}
              helperText={null}
              onBlur={handleBlur}
              inputVariant="outlined"
              // label="Start Date"
              onChange={(val) => {
                // setTouched({ ...touched, endDate: true });
                setFieldValue('date', val);
                return {value: val};
              }}
              autoOk
              margin="dense"
              touched={touched?.date}
              error={Boolean(touched?.date && errors?.date)}
            />
          </Grid>
        </MuiPickersUtilsProvider>
        <FormHelperText
          style={{color: 'red'}}
          margin="dense"
          variant="outlined"
          position="relative"
        >
          {touched?.date && errors && errors?.date}
        </FormHelperText>
      </Grid>
    </Grid>
  );
};
export default RequestALetter;
